import { useState, useEffect } from 'react';

const getScreenFlags = () => {
    const width = typeof window === "undefined" ? 1280 : window.innerWidth;

    if (width < 768) {
        return { isMobile: true, isTablet: false, isDesktop: false };
    }
    if (width < 1024) {
        return { isMobile: false, isTablet: true, isDesktop: false };
    }
    return { isMobile: false, isTablet: false, isDesktop: true };
};

export const useResponsive = () => {
    const [screen, setScreen] = useState(getScreenFlags);
    const { isMobile, isTablet, isDesktop } = screen;

    useEffect(() => {
        const checkScreenSize = () => {
            setScreen(getScreenFlags());
        };

        // Check on mount
        checkScreenSize();

        // Add event listener
        window.addEventListener('resize', checkScreenSize);

        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    return {
        isMobile,
        isTablet,
        isDesktop,
        screenSize: isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'
    };
};